import UserMobileUpdateModal from "./UserMobileUpdateModal";

export type { UserMobileUpdateModalHandle } from "./UserMobileUpdateModal";
export default UserMobileUpdateModal;
